const moneyFormat = '${{amount}}';
function formatMoney$1(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
var formatMoney = (val) =>
  formatMoney$1(
    val,
    window.themeVariables.settings.moneyFormat || '${{amount}}'
  );
function initializeCartDrawer() {
  const cartDrawer = document.querySelector('.cart-drawer');
  if (!cartDrawer) return;
  cartDrawer.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (
      !button ||
      (!button.classList.contains('is__plus') &&
        !button.classList.contains('is__minus'))
    ) {
      return;
    }
    event.stopPropagation();
    const isPlus = button.classList.contains('is__plus');
    const quantityInput = button.parentElement.querySelector('input');
    const value = Number(quantityInput.value);
    const key = button.closest('[data-key]').dataset.key;
    let newQuantity = isPlus ? value + 1 : value - 1;
    if (newQuantity > 0) {
      quantityInput.value = newQuantity;
      updateCart(key, newQuantity);
    }
  });
}
// Cart page (/cart): the line items render the same +/- buttons (mobile row in
// snippets/line-item.liquid), but nothing handled them outside the drawer. They
// use the same serialized updateCart as the drawer; the request also asks
// Shopify to render the main cart section, so line totals, totals, the
// free-shipping bar and the checkout form follow without a second request.
function initializeCartPage() {
  const settings = window.themeVariables && window.themeVariables.settings;
  if (!settings || settings.pageType !== 'cart') return;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (
      !button ||
      (!button.classList.contains('is__plus') &&
        !button.classList.contains('is__minus')) ||
      button.closest('.cart-drawer')
    ) {
      return;
    }
    const lineItem = button.closest('line-item[data-key]');
    const section = lineItem && lineItem.closest('.shopify-section');
    if (!section || !section.querySelector('.cart-order')) return;
    const quantityInput = button.parentElement.querySelector('input');
    if (!quantityInput) return;
    const isPlus = button.classList.contains('is__plus');
    const value = Number(quantityInput.value);
    const newQuantity = isPlus ? value + 1 : value - 1;
    if (!(newQuantity > 0)) return;
    quantityInput.value = newQuantity;
    updateCart(lineItem.dataset.key, newQuantity, section.id.replace('shopify-section-', ''));
  });
}
// Requests run one after another: parallel /cart/change.js calls can be applied
// by Shopify in a different order than they were sent (seen with a quick double
// click: the drawer showed 4, the cart kept 3). The quantity is absolute, so a
// queued request is skipped when a newer click for the same line follows, and
// only the newest answer per line updates the drawer and fires cart:change.
let cartChangeQueue = Promise.resolve();
let cartChangeSeq = 0;
const cartChangeLatest = {};
function updateCart(key, quantity, sectionId) {
  const requestData = { id: key, quantity: quantity };
  if (sectionId) {
    requestData.sections = [sectionId];
    requestData.sections_url = `${window.Shopify?.routes?.root || '/'}cart`;
  }
  const seq = ++cartChangeSeq;
  cartChangeLatest[key] = seq;

  cartChangeQueue = cartChangeQueue
    .then(() => {
      if (cartChangeLatest[key] !== seq) return;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          // Cart page: a rejected change (e.g. above stock) leaves the page on
          // a quantity the cart does not have; reload to show the real cart.
          if (!response.ok && sectionId) {
            window.location.reload();
            return null;
          }
          return response.json();
        })
        .then((cartData) => {
          if (!cartData || cartChangeLatest[key] !== seq) return;
          const sections = cartData.sections;
          delete cartData.sections;
          let rendered = false;
          if (sectionId && sections && sections[sectionId]) {
            const updated = new DOMParser()
              .parseFromString(sections[sectionId], 'text/html')
              .getElementById(`shopify-section-${sectionId}`);
            const current = document.getElementById(`shopify-section-${sectionId}`);
            if (updated && current) {
              current.replaceChildren(...updated.childNodes);
              rendered = true;
            }
          }
          if (!rendered) {
            updateLineItemPrices(cartData.items);
            updateSubtotal(cartData);
          }
          updateCartCount(cartData);
          // Same event the theme's LineItemQuantity fires (theme.js.liquid), so
          // the free-shipping bar, cart counters, fetchCart and the
          // begin_checkout value (denk-cart-attribution.js latestCart) follow
          // the +/- buttons too. The payload carries no `sections`, so
          // CartDrawer keeps its DOM (no re-render).
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'line-item:change', cart: cartData },
            })
          );
        });
    })
    .catch((error) => {
      console.error('Error updating cart:', error);
    });
}
function updateLineItemPrices(items) {
  items.forEach((item) => {
    const priceContainer = document.querySelector(
      `[data-key="${item.key}"] .final-sale__price`
    );
    if (priceContainer) {
      priceContainer.textContent = formatMoney(item.final_line_price);
    }
  });
}
function updateSubtotal(cartData) {
  const subtotal = document.querySelector('.cart__total-price span');
  if (subtotal) {
    subtotal.textContent = formatMoney(cartData.total_price);
  }
}
function updateCartCount(cartData) {
  document.querySelectorAll('.count-bubble').forEach((counter) => {
    if (counter) {
      counter.textContent = cartData.item_count;
    }
  });
}
function productDescriptionLinks() {
  const productInfo = document.querySelector('.custom-section > .product');
  if (!productInfo) return;

  const descriptionContent = productInfo.querySelector(
    '.description-content'
  );
  if (!descriptionContent) return;

  const downloadContainer = document.querySelector(
    '.product-media-section'
  );
  const gridContainer = downloadContainer?.querySelector(
    '.media__btn-grid'
  );
  if (!gridContainer) return;

  const elements = descriptionContent.querySelectorAll('a');
  let hasValidLinks = false;

  elements.forEach((linkEl) => {
    const href = linkEl.getAttribute('href');
    if (!href) return;

    // Match only PDF or Flipbook links
    const isFlipbook = href.includes(
      'https://flipbook.pagepreserve.com/'
    );
    const isPDF = /\.pdf(\?|$)/i.test(href);

    if (!isFlipbook && !isPDF) return;

    // Get label text from parent container up to the link
    let labelText = '';
    const parent = linkEl.closest('blockquote, p, span, div');

    if (parent) {
      let foundLink = false;
      parent.childNodes.forEach((node) => {
        if (node === linkEl) {
          foundLink = true;
          return;
        }
        if (!foundLink && node.nodeType === Node.TEXT_NODE) {
          labelText += node.textContent;
        }
      });
      labelText = labelText.replace(/[:\u00A0]/g, '').trim(); // remove colons, nbsp
    }

    if (!labelText) {
      labelText = linkEl.textContent.trim();
    }

    // Create button link
    const btn = document.createElement('a');
    btn.href = href;
    btn.textContent = labelText || 'Download';
    btn.setAttribute('target', '_blank');
    btn.setAttribute('rel', 'noopener noreferrer');
    btn.className = 'media__btn-link media__btn-link--doc';
    gridContainer.appendChild(btn);
    hasValidLinks = true;

    // Hide only the link in description und ersetze ihn durch einen Hinweistext
    const hinweis = document.createElement('span');
    hinweis.textContent = 'Button unten';
    linkEl.parentNode.insertBefore(hinweis, linkEl);
    linkEl.classList.add('hidden-download-meta');
    // parent.classList.add('hidden-download-meta'); // Entfernt, damit nicht das ganze Elternelement verschwindet
  });

  // Hide container only if no JS-extracted links AND no Liquid-rendered buttons exist
  if (!hasValidLinks && gridContainer.children.length === 0) {
    downloadContainer.style.display = 'none';
  }
}
document.addEventListener('DOMContentLoaded', () => {
  initializeCartDrawer();
  initializeCartPage();
  productDescriptionLinks();
});
